// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-list-nCeS74{flex-shrink:0;align-items:center;display:flex}.link-list-nCeS74 .link-list-item-dQotbo{color:rgba(255,255,255,.6);align-items:center;padding:0 18px;font-size:14px;line-height:22px;display:flex}.link-list-nCeS74 .link-list-item-dQotbo .click-area-mZvFnK{align-items:center;display:flex}.link-list-nCeS74 .link-list-item-dQotbo .click-area-mZvFnK.pointer-RPQG8E{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.link-list-nCeS74 .link-list-item-dQotbo .click-area-mZvFnK.pointer-RPQG8E:hover,.link-list-nCeS74 .link-list-item-dQotbo .click-area-mZvFnK.pointer-RPQG8E:active{color:#fff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link-list": `link-list-nCeS74`,
	"linkList": `link-list-nCeS74`,
	"link-list-item": `link-list-item-dQotbo`,
	"linkListItem": `link-list-item-dQotbo`,
	"click-area": `click-area-mZvFnK`,
	"clickArea": `click-area-mZvFnK`,
	"pointer": `pointer-RPQG8E`
};
export default ___CSS_LOADER_EXPORT___;
